import { SearchCrit } from './searchCrit';
import { Reference } from '../tools/api.service'

export class SearchResult {
  crit: SearchCrit;
  ref: Reference[];
}
